import partner1 from './barclays-incubator-logo.png'
import partner2 from './santander-logo.png'
import partner3 from './lawtech-panel-logo.png'
import partner4 from './wayrauk-logo.png'
import partner5 from './westminster-logo.png'
import partner6 from './edinburgh-logo.png'
import partner7 from './aberdeen-logo.png'
import partner8 from './aru-logo.png'
import partner9 from './bsb-logo.png'
import partner10 from './sra-logo.png'
import partner11 from './cma-logo.png'
import partner12 from './lsb-logo.png'
import partner13 from './legal-ombudsman-logo.png'
import partner14 from './dentons-logo.png'
import partner15 from './asa-logo.png'
import partner16 from './national-archives-logo.png'
import partner17 from './nrf-logo.png'
import partner18 from './baker-mckenzie-logo.png'
import partner19 from './mishcon-logo.png'

export const Section6Images = {
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
  partner11,
  partner12,
  partner13,
  partner14,
  partner15,
  partner16,
  partner17,
  partner18,
  partner19,
}
